// extracted by mini-css-extract-plugin
export default {"ErrorContainer":"ErrorMessage_ErrorContainer__EoHe3","Title":"ErrorMessage_Title__uV3J+","SubText":"ErrorMessage_SubText__V6S3L"};